/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import StyledSelect from 'app/components/common/StyledSelect.jsx';
import Toggle from 'app/components/common/ToggleControl.jsx';
import HelpButton from 'app/components/common/HelpButton.jsx';
import UncontrolledTextInput from 'app/components/common/UncontrolledTextInput.jsx';
import ErrorModule from 'app/mixins/ErrorModule.jsx';
import FieldError from 'app/components/common/FieldError.jsx';

class FilterPanel extends React.Component {
    render() {
        var andFilter = (this.props.andFilter) ? this.props.andFilter : '',
            orFilter = (this.props.orFilter) ? this.props.orFilter : '',
            notFilter = (this.props.notFilter) ? this.props.notFilter : '',
            warning = null,
            warningText = null,
            shouldShowWarning = () => {
                if (andFilter || orFilter || notFilter) {
                    if (!this.props.titleActive && !this.props.contentActive && !this.props.categoryActive && !this.props.authorActive && !this.props.linkActive) {
                        return 'toggle';
                    }
                } else if (this.props.titleActive || this.props.contentActive || this.props.categoryActive || this.props.authorActive || this.props.linkActive) {
                    if (!andFilter && !orFilter && !notFilter) {
                        return 'fields';
                    }
                }
                return null;
            };

        let showWarning = shouldShowWarning();
        if (showWarning) {
            switch (showWarning) {
                case 'toggle':
                    warningText = "Activate filters by selecting from the choices below";
                    break;

                case 'fields':
                    warningText = "Activate filters by adding terms below";
                    break;

                default:
                    break;
            }
            warning = (
                <div className="warning">
                    <i className="fa fa-exclamation-triangle" aria-hidden="true"/> {warningText}
                </div>
            );
        }

        return (
			<div className="editor-panel">
				<form>
					<fieldset>
						<legend>Choose what dlvr.it uses for filtering</legend>
                        <ErrorModule
                            app={this.props.app}
                            keys={['ROUTE_UPDATE', 'INPUT_UPDATE']}
                            render={(state) => {
                                return (
                                    <FieldError field="filtersTitle" errors={state.errors}/>
                                );
                            }}/>
                        <ErrorModule
                            app={this.props.app}
                            keys={['ROUTE_UPDATE', 'INPUT_UPDATE']}
                            render={(state) => {
                                return (
                                    <FieldError field="filtersContent" errors={state.errors}/>
                                );
                            }}/>
                        <ErrorModule
                            app={this.props.app}
                            keys={['ROUTE_UPDATE', 'INPUT_UPDATE']}
                            render={(state) => {
                                return (
                                    <FieldError field="filtersCategory" errors={state.errors}/>
                                );
                            }}/>
                        <ErrorModule
                            app={this.props.app}
                            keys={['ROUTE_UPDATE', 'INPUT_UPDATE']}
                            render={(state) => {
                                return (
                                    <FieldError field="filtersAuthor" errors={state.errors}/>
                                );
                            }}/>
                        <ErrorModule
                            app={this.props.app}
                            keys={['ROUTE_UPDATE', 'INPUT_UPDATE']}
                            render={(state) => {
                                return (
                                    <FieldError field="filtersLink" errors={state.errors}/>
                                );
                            }}/>
						<div className="toggle-list filters">
                            {(showWarning === 'toggle') ? warning : null}
							<div className="toggle-item">
							<Toggle
									active={this.props.titleActive}
									activeLabel="Title"
									inactiveLabel="Title"
									callback={this.props.updateField}
									linkedField={this.props.stateName + ".filtersTitle"}
									labelPlacement="right" />
							</div>
							<div className="toggle-item">
							<Toggle
									active={this.props.contentActive}
									activeLabel="Content"
									inactiveLabel="Content"
									callback={this.props.updateField}
									linkedField={this.props.stateName + ".filtersContent"}
									labelPlacement="right" />
							</div>
							<div className="toggle-item">
							<Toggle
									active={this.props.categoryActive}
									activeLabel="Category"
									inactiveLabel="Category"
									callback={this.props.updateField}
									linkedField={this.props.stateName + ".filtersCategory"}
									labelPlacement="right" />
							</div>
							<div className="toggle-item">
							<Toggle
									active={this.props.authorActive}
									activeLabel="Author"
									inactiveLabel="Author"
									callback={this.props.updateField}
									linkedField={this.props.stateName + ".filtersAuthor"}
									labelPlacement="right" />
							</div>
                            <div className="toggle-item">
                            <Toggle
									active={this.props.linkActive}
									activeLabel="Link"
									inactiveLabel="Link"
									callback={this.props.updateField}
									linkedField={this.props.stateName + ".filtersLink"}
									labelPlacement="right" />
							</div>
						</div>
					</fieldset>
					<fieldset>
						<legend>Filter behavior <HelpButton which="filterBehaviorSource"/></legend>
                        <ErrorModule
                            app={this.props.app}
                            keys={['ROUTE_UPDATE', 'INPUT_UPDATE']}
                            render={(state) => {
                                return (
                                    <FieldError field="filterBehavior" errors={state.errors}/>
                                );
                            }}/>
                        {(showWarning === 'fields') ? warning : null}
						<StyledSelect options={[{value: 1, label: 'Match whole words'}, {value: 0, label: 'Match sequence anywhere'}]}
										linkedField={this.props.stateName + ".filterBehavior"}
										value={this.props.behavior}
										onChange={this.props.updateField}
										selectClass="med" />
					</fieldset>
					<fieldset>
                        <ErrorModule
                            app={this.props.app}
                            keys={['ROUTE_UPDATE', 'INPUT_UPDATE']}
                            render={(state) => {
                                return (
                                    <FieldError field="andFilter" errors={state.errors}/>
                                );
                            }}/>
						<legend>Posted items must contain all the terms</legend>
						<UncontrolledTextInput
                            className="text-input small"
                            defaultValue={andFilter}
                            onChange={this.props.updateField}
                            data-field={this.props.stateName + ".andFilter"}/>
						<p className="help-text">Separate terms using a comma.</p>
					</fieldset>
					<fieldset>
                        <ErrorModule
                            app={this.props.app}
                            keys={['ROUTE_UPDATE', 'INPUT_UPDATE']}
                            render={(state) => {
                                return (
                                    <FieldError field="orFilter" errors={state.errors}/>
                                );
                            }}/>
						<legend>Posted items must contain any of the terms</legend>
						<UncontrolledTextInput
                            className="text-input small"
                            defaultValue={orFilter}
                            onChange={this.props.updateField}
                            data-field={this.props.stateName + ".orFilter"}/>
						<p className="help-text">Separate terms using a comma.</p>
					</fieldset>
					<fieldset>
                        <ErrorModule
                            app={this.props.app}
                            keys={['ROUTE_UPDATE', 'INPUT_UPDATE']}
                            render={(state) => {
                                return (
                                    <FieldError field="notFilter" errors={state.errors}/>
                                );
                            }}/>
						<legend>Ignore items that contain any of the terms</legend>
						<UncontrolledTextInput
                            className="text-input small"
                            defaultValue={notFilter}
                            onChange={this.props.updateField}
                            data-field={this.props.stateName + ".notFilter"}/>
						<p className="help-text">Separate terms using a comma.</p>
					</fieldset>
				</form>
			</div>
		);

    }

};

FilterPanel.displayName = "FilterPanel";

FilterPanel.propTypes = {
    andFilter: PropTypes.string,
    orFilter: PropTypes.string,
    notFilter: PropTypes.string,
    behavior: PropTypes.number,
    titleActive: PropTypes.bool,
    categoryActive: PropTypes.bool,
    contentActive: PropTypes.bool,
    authorActive: PropTypes.bool,
    linkActive: PropTypes.bool,
    updateField: PropTypes.func,
    stateName: PropTypes.string,
    errors: PropTypes.object
};

FilterPanel.defaultProps = {
    andFilter: '',
    orFilter: '',
    notFilter: '',
    behavior: 0,
    titleActive: true,
    categoryActive: true,
    contentActive: false,
    authorActive: false,
    linkActive: false,
    updateField: null,
    stateName: '',
    errors: null
};

export default FilterPanel;
